{
  "hr.nav.group": "الموارد البشرية",
  "hr.nav.myHr": "ملفي الوظيفي",
  "hr.nav.people": "شؤون الموظفين",
  "hr.people.title": "شؤون الموظفين",
  "hr.people.subtitle": "كل أعضاء الفريق وملفاتهم الوظيفية، ومن يتبع مَن.",
  "hr.tabs.label": "أقسام شؤون الموظفين",
  "hr.tabs.directory": "دليل الموظفين",
  "hr.tabs.orgChart": "الهيكل التنظيمي",
  "hr.record.open": "فتح ملف موظف",
  "hr.status.active": "على رأس العمل",
  "hr.status.upcoming": "ينضم قريبًا",
  "hr.status.former": "سابق",
  "hr.status.no_record": "بلا ملف",
  "hr.contract.full_time": "دوام كامل",
  "hr.contract.part_time": "دوام جزئي",
  "hr.contract.freelance": "عمل حر",
  "hr.workMode.office": "من المكتب",
  "hr.workMode.hybrid": "هجين",
  "hr.workMode.remote": "عن بُعد",
  "hr.hoursPolicy.flexible": "ساعات مرنة",
  "hr.hoursPolicy.flexibleHint": "أي ساعات تكتمل بها ساعات اليوم.",
  "hr.hoursPolicy.fixed": "ساعات ثابتة",
  "hr.hoursPolicy.fixedHint": "موعد محدد للحضور والانصراف.",
  "hr.documentKind.contract": "عقد عمل",
  "hr.documentKind.id_card": "بطاقة الرقم القومي",
  "hr.documentKind.cv": "سيرة ذاتية",
  "hr.documentKind.certificate": "شهادة",
  "hr.documentKind.medical": "مستند طبي",
  "hr.documentKind.other": "أخرى",
  "hr.jobKind.hired": "الانضمام إلى الفريق",
  "hr.jobKind.promoted": "ترقية",
  "hr.jobKind.promotedHint": "مسمى وظيفي جديد، وربما قسم جديد.",
  "hr.jobKind.transferred": "نقل",
  "hr.jobKind.transferredHint": "الانتقال إلى قسم آخر.",
  "hr.jobKind.manager_changed": "مدير جديد",
  "hr.jobKind.manager_changedHint": "أصبح يتبع شخصًا آخر.",
  "hr.jobKind.contract_changed": "عقد جديد",
  "hr.jobKind.contract_changedHint": "دوام كامل أو جزئي أو عمل حر.",
  "hr.jobKind.role_changed": "تغيير صلاحية الدخول",
  "hr.jobKind.left": "ترك العمل",
  "hr.value.none": "غير مُسجَّل",
  "hr.value.standardDay": "يوم العمل المعتاد",
  "hr.value.attendanceTracked": "يُسجَّل حضوره",
  "hr.value.attendanceExempt": "لا يُسجَّل حضوره",
  "hr.tiles.current": "على رأس العمل",
  "hr.tiles.currentCaption": "يعملون معنا اليوم",
  "hr.tiles.upcoming": "ينضمون قريبًا",
  "hr.tiles.upcomingCaption": "لم يحِن موعد بدايتهم بعد",
  "hr.tiles.noRecord": "بلا ملف وظيفي",
  "hr.tiles.noRecordCaption": "افتح لهم ملفات لمتابعة بياناتهم",
  "hr.tiles.noRecordDone": "لكل أعضاء الفريق ملفات",
  "hr.tiles.former": "موظفون سابقون",
  "hr.tiles.formerCaption": "تركوا العمل أو أُوقفت حساباتهم",
  "hr.tiles.none": "لا أحد",
  "hr.directory.filterLabel": "التصفية حسب الحالة",
  "hr.directory.filter.current": "الحاليون",
  "hr.directory.filter.upcoming": "ينضمون قريبًا",
  "hr.directory.filter.former": "السابقون",
  "hr.directory.filter.no_record": "بلا ملف",
  "hr.directory.filter.all": "الكل",
  "hr.directory.departmentLabel": "التصفية حسب القسم",
  "hr.directory.allDepartments": "كل الأقسام",
  "hr.directory.search": "ابحث في الدليل",
  "hr.directory.caption": "دليل الموظفين",
  "hr.directory.columns.person": "الموظف",
  "hr.directory.columns.department": "القسم",
  "hr.directory.columns.manager": "المدير المباشر",
  "hr.directory.columns.code": "الرقم الوظيفي",
  "hr.directory.columns.status": "الحالة",
  "hr.directory.columns.contract": "العقد",
  "hr.directory.columns.hireDate": "تاريخ التعيين",
  "hr.directory.openRecord": "فتح ملف",
  "hr.directory.openRecordFor": "فتح ملف وظيفي لـ{name}",
  "hr.directory.noRecordOpen": "بلا ملف · افتح ملفًا",
  "hr.directory.loadError": "تعذّر تحميل دليل الموظفين.",
  "hr.directory.empty.title": "لا يوجد أحد هنا بعد",
  "hr.directory.empty.body": "يظهر أعضاء الفريق هنا بمجرد انضمامهم.",
  "hr.directory.noResults.title": "لا توجد نتائج مطابقة",
  "hr.directory.noResults.body": "جرّب اسمًا أو حالة أو قسمًا آخر.",
  "hr.directory.noResults.clear": "مسح عوامل التصفية",
  "hr.create.title": "فتح ملف وظيفي",
  "hr.create.description": "ابدأ بالأساسيات، ثم أكمل بيانات التواصل والهوية والتأمين من صفحة الموظف.",
  "hr.create.step.person": "لمن هذا الملف؟",
  "hr.create.step.employment": "بيانات التوظيف",
  "hr.create.step.work": "نظام العمل",
  "hr.create.person": "عضو الفريق",
  "hr.create.personPlaceholder": "اختر شخصًا ليس له ملف",
  "hr.create.personSearch": "ابحث في الفريق",
  "hr.create.everyoneRecorded": "لكل أعضاء الفريق ملفات وظيفية بالفعل.",
  "hr.create.codeHint": "الرقم التالي في التسلسل، ويمكنك تغييره إن كنت تستخدم رقمًا آخر.",
  "hr.create.submit": "فتح الملف",
  "hr.create.submitting": "جارٍ فتح الملف…",
  "hr.create.created": "تم فتح ملف {name}.",
  "hr.create.errors.person": "اختر الشخص الذي يُفتح له الملف.",
  "hr.form.code": "الرقم الوظيفي",
  "hr.form.hireDate": "تاريخ التعيين",
  "hr.form.probationEnd": "نهاية فترة الاختبار",
  "hr.form.endDate": "آخر يوم عمل",
  "hr.form.endDateHint": "فقط عند ترك العمل أو قرب موعده.",
  "hr.form.contractType": "نوع العقد",
  "hr.form.contractEnd": "نهاية العقد",
  "hr.form.manager": "المدير المباشر",
  "hr.form.managerNone": "بدون مدير",
  "hr.form.managerSearch": "ابحث عن مدير",
  "hr.form.peopleEmpty": "لا توجد نتائج.",
  "hr.form.departmentNone": "بدون قسم",
  "hr.form.workMode": "مكان العمل",
  "hr.form.hoursPolicy": "ساعات العمل",
  "hr.form.dailyHours": "الساعات اليومية",
  "hr.form.dailyHoursHint": "اتركه فارغًا ليُطبَّق يوم العمل المعتاد. لدوام جزئي اكتب ساعاته، مثل 6 أو 4:30.",
  "hr.form.dailyHoursPlaceholder": "المعتاد",
  "hr.form.hoursUnit": "ساعات",
  "hr.form.attendance": "الحضور",
  "hr.form.attendanceRequired": "تسجيل الحضور والانصراف",
  "hr.form.attendanceRequiredHint": "يسجّل حضوره وانصرافه، وتُحتسب أيامه في كشف الحضور.",
  "hr.form.deviceId": "رقم البصمة",
  "hr.form.deviceIdHint": "رقمه على جهاز البصمة في المكتب.",
  "hr.form.workEmail": "بريد العمل",
  "hr.form.workPhone": "هاتف العمل",
  "hr.form.personalPhone": "الهاتف الشخصي",
  "hr.form.personalEmail": "البريد الشخصي",
  "hr.form.phoneHint": "مثل 010 0123 4567.",
  "hr.form.address": "عنوان السكن",
  "hr.form.birthDate": "تاريخ الميلاد",
  "hr.form.emergencyName": "اسم جهة الاتصال",
  "hr.form.emergencyRelation": "صلة القرابة",
  "hr.form.emergencyRelationPlaceholder": "مثل الزوجة أو الأخ",
  "hr.form.emergencyPhone": "رقم جهة الاتصال",
  "hr.form.nationalId": "الرقم القومي",
  "hr.form.socialInsurance": "الرقم التأميني",
  "hr.form.insurer": "شركة التأمين",
  "hr.form.policyNumber": "رقم الوثيقة",
  "hr.form.dependents": "عدد التابعين المؤمَّن عليهم",
  "hr.form.gender": "النوع",
  "hr.form.genderUnset": "غير مسجّل",
  "hr.form.genderMale": "ذكر",
  "hr.form.genderFemale": "أنثى",
  "hr.form.priorService": "مدة الخدمة السابقة الموثقة (بالشهور)",
  "hr.form.priorServiceHint": "الخدمة عند أصحاب عمل سابقين بعد التحقق منها. تُحسب في استحقاق الثلاثين يومًا بعد ١٠ سنوات.",
  "hr.form.disability": "من ذوي الإعاقة",
  "hr.form.disabilityHint": "٤٥ يوم إجازة سنوية في السنة (م ١٢٤).",
  "hr.form.hazardous": "عمل خطر أو في منطقة نائية",
  "hr.form.hazardousHint": "٧ أيام إجازة سنوية إضافية في السنة (م ١٢٤).",
  "hr.form.errors.priorService": "اكتب عدد شهور صحيح، حتى ٦٠٠.",
  "hr.form.notes": "الملاحظات",
  "hr.form.errors.code": "استخدم من 2 إلى 20 حرفًا أو رقمًا أو شرطة.",
  "hr.form.errors.dailyHours": "اكتب من ساعة إلى 12 ساعة، مثل 8 أو 6:30.",
  "hr.form.errors.dependents": "اكتب عددًا صحيحًا من 0 إلى 20.",
  "hr.form.errors.email": "اكتب بريدًا إلكترونيًا صحيحًا.",
  "hr.form.errors.phone": "اكتب رقم هاتف صحيحًا، مثل 010 0123 4567.",
  "hr.form.errors.tooLong": "النص أطول من المسموح.",
  "hr.errors.notFound": "لم نعثر على هذا الملف الوظيفي.",
  "hr.errors.exists": "لهذا الشخص ملف وظيفي بالفعل.",
  "hr.errors.codeTaken": "هذا الرقم الوظيفي مستخدم لموظف آخر.",
  "hr.errors.deviceTaken": "رقم البصمة هذا مستخدم لموظف آخر.",
  "hr.errors.managerNotFound": "اختر مديرًا من أعضاء الفريق الحاليين.",
  "hr.errors.managerCycle": "هذا الشخص يتبع الموظف نفسه، فلا يمكن أن يكون مديره.",
  "hr.errors.dates": "راجع التواريخ: نهاية الاختبار ونهاية العقد وآخر يوم عمل كلها في تاريخ التعيين أو بعده.",
  "hr.errors.jobChangeFuture": "سجّل التغيير بتاريخ اليوم أو قبله.",
  "hr.errors.jobChangeEmpty": "غيّر شيئًا واحدًا على الأقل لتسجيل التغيير الوظيفي.",
  "hr.errors.documentType": "أرفق ملف PDF أو PNG أو JPEG أو WebP.",
  "hr.errors.documentSize": "حجم الملف أكبر من 10 ميجابايت.",
  "hr.errors.documentNotFound": "هذا المستند لم يعد موجودًا.",
  "hr.errors.certificationNotFound": "هذه الشهادة لم تعد موجودة.",
  "hr.org.search": "ابحث عن شخص في الهيكل",
  "hr.org.matchPosition": "{position} من {total}",
  "hr.org.noMatches": "لا توجد نتائج",
  "hr.org.previousMatch": "النتيجة السابقة",
  "hr.org.nextMatch": "النتيجة التالية",
  "hr.org.expandAll": "توسيع الكل",
  "hr.org.collapseAll": "طي الكل",
  "hr.org.showReports": "إظهار فريق {name} المباشر ({count, plural, one {شخص واحد} two {شخصان} few {# أشخاص} many {# شخصًا} other {# شخص}})",
  "hr.org.hideReports": "إخفاء فريق {name} المباشر ({count, plural, one {شخص واحد} two {شخصان} few {# أشخاص} many {# شخصًا} other {# شخص}})",
  "hr.org.loadError": "تعذّر تحميل الهيكل التنظيمي.",
  "hr.org.empty.title": "لم تُحدَّد خطوط التبعية بعد",
  "hr.org.empty.body": "حدّد المدير المباشر في ملف كل موظف، وسيُرسم الهيكل تلقائيًا.",
  "hr.profile.loading": "جارٍ التحميل…",
  "hr.profile.edit": "تعديل الملف",
  "hr.profile.backToPeople": "العودة إلى شؤون الموظفين",
  "hr.profile.loadError": "تعذّر تحميل هذا الملف",
  "hr.profile.missing.title": "لا يوجد ملف وظيفي",
  "hr.profile.missing.body": "لم تفتح الموارد البشرية ملفًا لهذا الشخص بعد، أو أن الرابط غير مكتمل.",
  "hr.profile.tabs.label": "أقسام الملف الوظيفي",
  "hr.profile.tabs.overview": "نظرة عامة",
  "hr.profile.tabs.timeline": "المسار الوظيفي",
  "hr.profile.tabs.documents": "المستندات",
  "hr.profile.tabs.certifications": "الشهادات",
  "hr.facts.label": "أهم البيانات",
  "hr.facts.joinedFor": "انضم في {date} · {duration}",
  "hr.facts.joins": "ينضم في {date}",
  "hr.facts.noHireDate": "لم يُسجَّل تاريخ التعيين",
  "hr.facts.reportsTo": "يتبع {name}",
  "hr.facts.noManager": "بدون مدير مباشر",
  "hr.tenure.yearsMonths": "{years, plural, one {سنة} two {سنتان} few {# سنوات} many {# سنة} other {# سنة}} و{months, plural, one {شهر} two {شهران} few {# أشهر} many {# شهرًا} other {# شهر}}",
  "hr.tenure.years": "{years, plural, one {سنة} two {سنتان} few {# سنوات} many {# سنة} other {# سنة}}",
  "hr.tenure.months": "{months, plural, one {شهر} two {شهران} few {# أشهر} many {# شهرًا} other {# شهر}}",
  "hr.tenure.new": "انضم هذا الشهر",
  "hr.section.employment": "بيانات التوظيف",
  "hr.section.workSetup": "نظام العمل",
  "hr.section.contact": "بيانات التواصل",
  "hr.section.emergency": "جهة الاتصال في الطوارئ",
  "hr.section.emergencyEmpty": "لم تُسجَّل جهة اتصال للطوارئ بعد.",
  "hr.section.identity": "بيانات الهوية",
  "hr.section.identityEmpty": "لم تُسجَّل أرقام الهوية بعد.",
  "hr.section.insurance": "التأمين الطبي",
  "hr.section.insuranceEmpty": "لا توجد بيانات تأمين طبي.",
  "hr.section.leaveFacts": "استحقاق الإجازات",
  "hr.section.leaveFactsHint": "بيانات يربطها القانون بالإجازات. تظهر للموارد البشرية فقط.",
  "hr.section.notes": "ملاحظات الموارد البشرية",
  "hr.section.notesHint": "خاصة بالموارد البشرية، ولا يراها الموظف أبدًا.",
  "hr.section.noNotes": "لا توجد ملاحظات بعد.",
  "hr.section.directReports": "الفريق المباشر",
  "hr.section.noReports": "لا أحد",
  "hr.expiry.never": "بلا تاريخ انتهاء",
  "hr.expiry.today": "تنتهي صلاحيته اليوم",
  "hr.expiry.soon": "تنتهي صلاحيته خلال {days, plural, one {يوم واحد} two {يومين} few {# أيام} many {# يومًا} other {# يوم}}",
  "hr.expiry.expired": "انتهت صلاحيته منذ {days, plural, one {يوم واحد} two {يومين} few {# أيام} many {# يومًا} other {# يوم}}",
  "hr.ends.today": "ينتهي اليوم",
  "hr.ends.soon": "ينتهي خلال {days, plural, one {يوم واحد} two {يومين} few {# أيام} many {# يومًا} other {# يوم}}",
  "hr.ends.ended": "انتهى",
  "hr.identity.reveal": "إظهار",
  "hr.identity.hide": "إخفاء",
  "hr.identity.auditNotice": "يُسجَّل كل إظهار للأرقام الكاملة في سجل النشاط، وتُخفى تلقائيًا بعد {seconds} ثانية.",
  "hr.identity.maskedNotice": "تظهر آخر أربعة أرقام فقط حفاظًا على خصوصية هذه البيانات.",
  "hr.edit.title": "تعديل الملف الوظيفي",
  "hr.edit.label": "تعديل ملف {name}",
  "hr.edit.description": "تُحفظ الحقول التي تغيّرها فقط. ولتسجيل ترقية أو نقل بتاريخ وسبب، استخدم المسار الوظيفي.",
  "hr.edit.employmentHint": "تغيير المدير أو العقد أو آخر يوم عمل يُضاف أيضًا إلى المسار الوظيفي.",
  "hr.edit.identityHint": "هذه الأرقام مشفّرة. اكتب رقمًا جديدًا فقط إن أردت استبدال المسجَّل.",
  "hr.edit.sealedReplace": "المسجَّل ينتهي بـ {code}. اتركه فارغًا للإبقاء عليه.",
  "hr.edit.sealedEmpty": "لم يُسجَّل بعد.",
  "hr.edit.save": "حفظ التغييرات",
  "hr.edit.saving": "جارٍ الحفظ…",
  "hr.edit.saved": "تم حفظ ملف {name}.",
  "hr.edit.conflict.title": "حفظ شخص آخر هذا الملف",
  "hr.edit.conflict.body": "أعد التحميل لترى تغييراته. سيُستبدل ما كتبته هنا، فدوّن ما تحتاجه أولًا.",
  "hr.edit.conflict.reload": "إعادة تحميل الملف",
  "hr.timeline.title": "المسار الوظيفي",
  "hr.timeline.description": "كل تعيين وترقية ونقل وتغيير في العقد، من الأحدث إلى الأقدم.",
  "hr.timeline.effective": "اعتبارًا من {date}",
  "hr.timeline.recordedBy": "سجّله {name} · {when}",
  "hr.timeline.field.title": "المسمى الوظيفي",
  "hr.timeline.field.department": "القسم",
  "hr.timeline.field.manager": "المدير المباشر",
  "hr.timeline.field.contract_type": "العقد",
  "hr.timeline.field.role": "صلاحية الدخول",
  "hr.timeline.becomes": "أصبح",
  "hr.timeline.cleared": "لا شيء",
  "hr.timeline.loadError": "تعذّر تحميل المسار الوظيفي.",
  "hr.timeline.empty.title": "لا توجد خطوات وظيفية بعد",
  "hr.timeline.empty.body": "تظهر هنا الترقيات وحالات النقل وتغييرات العقد بمجرد تسجيلها.",
  "hr.jobChange.open": "تسجيل تغيير وظيفي",
  "hr.jobChange.title": "تسجيل تغيير وظيفي",
  "hr.jobChange.description": "يُطبَّق على {name} فورًا، ويبقى في مساره الوظيفي مع سببه.",
  "hr.jobChange.kind": "ما الذي تغيّر؟",
  "hr.jobChange.effectiveOn": "تاريخ السريان",
  "hr.jobChange.effectiveHint": "اليوم أو قبله.",
  "hr.jobChange.newTitle": "المسمى الجديد",
  "hr.jobChange.newDepartment": "القسم",
  "hr.jobChange.newManager": "المدير الجديد",
  "hr.jobChange.newContract": "العقد الجديد",
  "hr.jobChange.current": "الحالي: {label}",
  "hr.jobChange.departmentsUnavailable": "ليست لديك صلاحية الاطلاع على قائمة الأقسام.",
  "hr.jobChange.reason": "السبب",
  "hr.jobChange.reasonHint": "يبقى في المسار الوظيفي لمن يطّلع عليه لاحقًا.",
  "hr.jobChange.submit": "تسجيل التغيير",
  "hr.jobChange.submitting": "جارٍ التسجيل…",
  "hr.jobChange.recorded": "تم تسجيل التغيير الوظيفي لـ{name}.",
  "hr.jobChange.errors.date": "اختر تاريخ سريان التغيير.",
  "hr.jobChange.errors.title": "اكتب المسمى الوظيفي الجديد.",
  "hr.jobChange.errors.reason": "اكتب سببًا لا يقل عن 3 أحرف.",
  "hr.documents.title": "المستندات",
  "hr.documents.description": "العقود وصور الهوية والشهادات، محفوظة في سرية بين الموارد البشرية والموظف.",
  "hr.documents.caption": "مستندات الموظف",
  "hr.documents.columns.name": "المستند",
  "hr.documents.columns.kind": "النوع",
  "hr.documents.columns.expires": "تاريخ الانتهاء",
  "hr.documents.columns.size": "الحجم",
  "hr.documents.columns.added": "أُضيف في",
  "hr.documents.columns.actions": "الإجراءات",
  "hr.documents.open": "فتح {name}",
  "hr.documents.edit": "تعديل {name}",
  "hr.documents.remove": "حذف {name}",
  "hr.documents.attention": "{count, plural, one {مستند واحد يحتاج} two {مستندان يحتاجان} few {# مستندات تحتاج} many {# مستندًا تحتاج} other {# مستند تحتاج}} إلى متابعة",
  "hr.documents.attentionBody": "المستندات المنتهية أو التي تنتهي خلال 30 يومًا مُعلَّمة في القائمة.",
  "hr.documents.loadError": "تعذّر تحميل المستندات.",
  "hr.documents.empty.title": "لا توجد مستندات بعد",
  "hr.documents.empty.body": "ارفع عقد {name} وصورة هويته وشهاداته ليكون كل شيء في مكان واحد.",
  "hr.documents.empty.bodyReadOnly": "لم تُضِف الموارد البشرية مستندات لـ{name} بعد.",
  "hr.documents.upload.open": "رفع مستند",
  "hr.documents.upload.title": "رفع مستند",
  "hr.documents.upload.description": "يُحفظ في ملف {name}، ولا يطّلع عليه إلا الموارد البشرية وصاحب الملف.",
  "hr.documents.upload.drop": "اسحب الملف وأفلته هنا، أو اختر ملفًا",
  "hr.documents.upload.formats": "PDF أو PNG أو JPEG أو WebP، بحد أقصى 10 ميجابايت",
  "hr.documents.upload.remove": "اختيار ملف آخر",
  "hr.documents.upload.required": "اختر ملفًا لرفعه.",
  "hr.documents.upload.submit": "رفع",
  "hr.documents.upload.sending": "جارٍ الرفع…",
  "hr.documents.uploaded": "تم رفع {name}.",
  "hr.documents.kind": "النوع",
  "hr.documents.name": "الاسم",
  "hr.documents.expiresOn": "تاريخ الانتهاء",
  "hr.documents.expiresHint": "ننبّهك قبله بثلاثين يومًا.",
  "hr.documents.editTitle": "تعديل المستند",
  "hr.documents.save": "حفظ",
  "hr.documents.saved": "تم حفظ {name}.",
  "hr.documents.errors.name": "اكتب اسمًا للمستند.",
  "hr.documents.removeConfirm.title": "حذف {name}؟",
  "hr.documents.removeConfirm.body": "سيُحذف الملف نهائيًا، وتبقى بيانات الشهادات المرتبطة به كما هي.",
  "hr.documents.removeConfirm.confirm": "حذف المستند",
  "hr.documents.removeConfirm.removing": "جارٍ الحذف…",
  "hr.documents.removed": "تم حذف {name}.",
  "hr.certifications.title": "الشهادات",
  "hr.certifications.description": "الشهادات المهنية والدورات التدريبية، ومواعيد انتهائها.",
  "hr.certifications.open": "إضافة شهادة",
  "hr.certifications.loadError": "تعذّر تحميل الشهادات.",
  "hr.certifications.empty.title": "لا توجد شهادات بعد",
  "hr.certifications.empty.body": "أضف الشهادات والدورات لتعرف مؤهلات الفريق ومواعيد تجديدها.",
  "hr.certifications.addTitle": "إضافة شهادة",
  "hr.certifications.editTitle": "تعديل الشهادة",
  "hr.certifications.name": "اسم الشهادة",
  "hr.certifications.namePlaceholder": "مثل Google Ads Search",
  "hr.certifications.issuer": "جهة الإصدار",
  "hr.certifications.issuedOn": "تاريخ الإصدار",
  "hr.certifications.expiresOn": "تاريخ الانتهاء",
  "hr.certifications.document": "ملف الشهادة",
  "hr.certifications.documentHint": "اربطها بملف من مستندات الموظف.",
  "hr.certifications.noDocument": "بدون ملف",
  "hr.certifications.add": "إضافة",
  "hr.certifications.save": "حفظ",
  "hr.certifications.added": "تمت إضافة {name}.",
  "hr.certifications.saved": "تم حفظ {name}.",
  "hr.certifications.edit": "تعديل {name}",
  "hr.certifications.remove": "حذف {name}",
  "hr.certifications.removed": "تم حذف {name}.",
  "hr.certifications.removeConfirm.title": "حذف {name}؟",
  "hr.certifications.removeConfirm.body": "ستُحذف الشهادة من الملف، ويبقى الملف المرتبط بها في المستندات.",
  "hr.certifications.removeConfirm.confirm": "حذف الشهادة",
  "hr.certifications.errors.name": "اكتب اسم الشهادة.",
  "hr.certifications.errors.expiry": "تاريخ الانتهاء يأتي بعد تاريخ الإصدار.",
  "hr.me.title": "ملفي الوظيفي",
  "hr.me.subtitle": "بياناتك الوظيفية في 404 Creative كما تحفظها الموارد البشرية.",
  "hr.me.update": "تحديث بياناتي",
  "hr.me.updateTitle": "تحديث بياناتي",
  "hr.me.updateDescription": "حدّث وسائل التواصل معك وجهة الاتصال في الطوارئ، وتتولى الموارد البشرية باقي البيانات.",
  "hr.me.reachTitle": "وسائل التواصل معك",
  "hr.me.reachHint": "تُستخدم فقط عندما تحتاج الموارد البشرية للتواصل معك خارج العمل.",
  "hr.me.emergencyHint": "من نتصل به إن حدث لك طارئ أثناء العمل.",
  "hr.me.save": "حفظ بياناتي",
  "hr.me.saved": "تم حفظ بياناتك.",
  "hr.me.loadError": "تعذّر تحميل ملفك الوظيفي.",
  "hr.me.empty.title": "لم يُفتح ملفك الوظيفي بعد",
  "hr.me.empty.body": "تفتح الموارد البشرية ملفًا لكل عضو في الفريق. وبمجرد تجهيز ملفك ستظهر هنا بيانات وظيفتك وبيانات التواصل ومستنداتك.",
  "hr.me.documentsTitle": "مستنداتي",
  "hr.me.documentsHint": "ملفات تحفظها لك الموارد البشرية، ولإضافة ملف أو استبداله تواصل معها.",
  "hr.me.documentsEmpty": "لا توجد مستندات بعد.",
  "hr.tabs.attendance": "الحضور",
  "hr.tabs.timeOff": "الإجازات",
  "hr.tabs.lifecycle": "التعيين وإنهاء الخدمة",
  "hr.tabs.assets": "العُهد",
  "hr.tabs.letters": "الخطابات",
  "hr.profile.tabs.attendance": "الحضور",
  "hr.profile.tabs.timeOff": "الإجازات",
  "hr.profile.tabs.pay": "الراتب",
  "hr.profile.tabs.lifecycle": "القوائم والعُهد",
  "hr.me.tabs.label": "أقسام ملفي الوظيفي",
  "hr.me.tabs.overview": "نظرة عامة",
  "hr.me.tabs.attendance": "الحضور",
  "hr.me.tabs.timeOff": "الإجازات",
  "hr.me.tabs.pay": "راتبي",
  "hr.me.tabs.letters": "الخطابات والعُهد",
  "hr.nav.requests": "الطلبات",
  "hr.nav.payroll": "المرتبات",
  "hr.me.tabs.growth": "التطوير والأداء",
  "hr.tabs.performance": "الأداء",
  "hr.nav.hiring": "التوظيف",
  "hr.tabs.engagement": "التواصل والمشاركة",
  "hr.tabs.reports": "التقارير",
  "hr.nav.company": "أخبار الشركة",
  "hr.tabs.settings": "الإعدادات",
  "hr.accommodations.title": "ساعات عمل مخفّضة",
  "hr.accommodations.description": "دقايق أقل مطلوبة في اليوم لفترة. للموارد البشرية بس، وسبب كل تخفيض بيفضل في السجل.",
  "hr.accommodations.lawTitle": "القانون بيقول إيه",
  "hr.accommodations.law.pregnancy": "الحمل: ساعة على الأقل أقل في اليوم من الشهر السادس (م. 54).",
  "hr.accommodations.law.nursing": "الرضاعة: ساعة في اليوم، أو نص ساعة مرتين، لمدة سنتين بعد الولادة، وبتتحسب من وقت الشغل (م. 56).",
  "hr.accommodations.law.medical": "طبي: أيام أقصر طلبها الدكتور. التفاصيل تتكتب في السجل مش هنا.",
  "hr.accommodations.law.other": "أي ترتيب تاني وافقت عليه الموارد البشرية.",
  "hr.accommodations.law.overtime": "طول ما وقت الحمل أو الرضاعة مغطي اليوم، مينفعش يتطلب ساعات إضافية، لحد ستة شهور بعد الولادة.",
  "hr.accommodations.empty": "مفيش ساعات مخفّضة متسجلة.",
  "hr.accommodations.loadError": "تعذّر تحميل الساعات المخفّضة.",
  "hr.accommodations.add": "إضافة",
  "hr.accommodations.addTitle": "إضافة ساعات مخفّضة",
  "hr.accommodations.editTitle": "تعديل الساعات المخفّضة",
  "hr.accommodations.save": "حفظ",
  "hr.accommodations.added": "اتضافت الساعات المخفّضة.",
  "hr.accommodations.saved": "اتحفظت الساعات المخفّضة.",
  "hr.accommodations.edit": "تعديل {label}",
  "hr.accommodations.remove": "حذف {label}",
  "hr.accommodations.removeTitle": "حذف الساعات المخفّضة دي؟",
  "hr.accommodations.removeBody": "الأيام اللي كانت مغطية بترجع ساعات كاملة. أيام الشهور المقفولة بتفضل زي ما هي.",
  "hr.accommodations.removeConfirm": "حذف",
  "hr.accommodations.removed": "اتحذفت الساعات المخفّضة.",
  "hr.accommodations.kind": "النوع",
  "hr.accommodations.kinds.pregnancy": "حمل",
  "hr.accommodations.kinds.nursing": "رضاعة",
  "hr.accommodations.kinds.medical": "طبي",
  "hr.accommodations.kinds.other": "أخرى",
  "hr.accommodations.state.current": "سارية",
  "hr.accommodations.state.upcoming": "قادمة",
  "hr.accommodations.state.ended": "انتهت",
  "hr.accommodations.summary": "{minutes, plural, one {دقيقة واحدة} two {دقيقتين} few {# دقائق} many {# دقيقة} other {# دقيقة}} أقل في اليوم · {start} – {end}",
  "hr.accommodations.startsOn": "من",
  "hr.accommodations.birthDate": "تاريخ الولادة",
  "hr.accommodations.endsOn": "لحد",
  "hr.accommodations.minutesPerDay": "دقايق أقل في اليوم",
  "hr.accommodations.minutesHint.pregnancy": "60 على الأقل بالقانون.",
  "hr.accommodations.minutesHint.nursing": "60 بالقانون: ساعة، أو نص ساعة مرتين.",
  "hr.accommodations.minutesHint.medical": "زي ما الدكتور طلب.",
  "hr.accommodations.minutesHint.other": "زي ما اتفقتوا.",
  "hr.accommodations.reason": "السبب",
  "hr.accommodations.reasonHint": "بيتحفظ في السجل، ومبيظهرش في الملف أبدًا.",
  "hr.accommodations.errors.startsOn": "اختار أول يوم.",
  "hr.accommodations.errors.endsOn": "اختار آخر يوم.",
  "hr.accommodations.errors.endsBeforeStart": "آخر يوم مينفعش يكون قبل أول يوم.",
  "hr.accommodations.errors.minutes": "اكتب دقايق صحيحة من ١ لـ ٤٨٠.",
  "hr.accommodations.errors.reason": "قول السبب في كلمتين.",
  "hr.accommodations.errors.gone": "الساعات المخفّضة دي اتحذفت قبل كده."
}
